/* Edge measurement layer — lightweight custom analytics (Sprint: measurement).
   ONE helper that fans a custom event out to GA4 (gtag), the dataLayer (GTM),
   and Clarity. Standard ecommerce events (view_item / add_to_cart / purchase)
   are intentionally NOT duplicated here — Shopify's GA4 integration owns those.
   We only fire events that answer a commercial question Shopify can't.
   Config injected as window.EdgeTrackConfig by sections/edge-measurement.liquid. */
(function () {
  'use strict';
  var CFG = window.EdgeTrackConfig || {};

  function consentOk() {
    if (!CFG.respectConsent) return true;
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed();
      }
    } catch (e) {}
    return true; // best-effort if the consent API isn't present
  }

  function send(name, params) {
    params = params || {};
    if (!consentOk()) { if (CFG.debug) console.log('[EdgeTrack] skipped (consent):', name); return; }
    // GA4
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch (e) {}
    // GTM / dataLayer
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params)); } catch (e) {}
    // Clarity (qualitative correlation)
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
    if (CFG.debug) console.log('[EdgeTrack]', name, params);
  }

  window.EdgeTrack = { event: send };

  // ---------- delegated listeners (no per-element wiring needed) ----------
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Generic: anything marked data-edge-event fires on click
    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-edge-event]');
      if (el) {
        var p = {};
        for (var i = 0; i < el.attributes.length; i++) {
          var a = el.attributes[i];
          if (a.name.indexOf('data-edge-') === 0 && a.name !== 'data-edge-event') {
            p[a.name.slice(10).replace(/-/g, '_')] = a.value;
          }
        }
        send(el.getAttribute('data-edge-event'), p);
      }
      // Cart -> checkout intent (commercial Q: cart->checkout friction)
      var co = e.target.closest('[name="checkout"], [data-edge-checkout]');
      if (co) send('cart_checkout_click', {});
      // Product / collection clicks (commercial Q: which products & collections attract interest)
      if (!el) {
        var link = e.target.closest('a[href]');
        if (link) {
          var href = link.getAttribute('href') || '';
          var m;
          if ((m = href.match(/\/products\/([\w-]+)/))) send('product_click', { handle: m[1] });
          else if ((m = href.match(/\/collections\/([\w-]+)/))) send('collection_click', { handle: m[1] });
        }
      }
    }, true);

    // Newsletter (Shopify customer forms) — commercial Q: which surface grows the owned list
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.matches && f.matches('form[action*="/contact"]')) {
        var hasEmail = f.querySelector('input[type="email"], input[name="contact[email]"]');
        if (hasEmail) send('newsletter_signup', { source: 'shopify_form' });
      }
    }, true);

    // PDP accordions — commercial Q: what info gift-buyers need (does our content earn its place)
    document.querySelectorAll('details.pdt__item').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        var s = d.querySelector('.pdt__summary');
        send('pdp_detail_open', { detail: s ? s.textContent.trim().slice(0, 60) : '' });
      });
    });

    // PDP gifting narrative seen — commercial Q: is the premium gift story actually viewed?
    var story = document.querySelector('[data-section-type="pdp-gift-story"], [data-section-type="pdp-story"]');
    if (story && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { send('pdp_gift_story_view', {}); io.disconnect(); }
        });
      }, { threshold: 0.5 });
      io.observe(story);
    }
  });
})();
